/**
*功能名称：必填
*创 建 人：弋强
*日    期：2022/08/17 09:23:59
*/
import { BaseVue, EventBus } from "@newview/base-web";
import { Component, Prop, Watch } from "vue-property-decorator";
import { dataGrid, comForm, customModal, DataGridApi, nvTag } from "@newview/ui";
import { ActReFlowApi, ActReFlowTypeApi } from "@newview/basics-v2-api";
import { ActivitiServiceApi } from "@newview/activiti-api";
import { ApprovePage } from "@newview/basics-v2-plugin";
import { UserprojectdatarelationApi } from "@newview/system-api";

@Component({
    components: {
        dataGrid, customModal, comForm, nvTag, ApprovePage
    }
})
export default class MyToDo extends BaseVue {

    //#region 接口定义区

    private readonly actReFlowApi: ActReFlowApi = new ActReFlowApi();
    private readonly actReFlowTypeApi: ActReFlowTypeApi = new ActReFlowTypeApi();
    private readonly activitiServiceApi: ActivitiServiceApi = new ActivitiServiceApi();
    userprojectdatarelationApi: UserprojectdatarelationApi = new UserprojectdatarelationApi()

    //#endregion 接口定义区

    //#region 变量定义区

    // 流程类型
    flowTypes: any[] = [];
    selectedType: any = "all";
    searchText: string = "";
    activeIndex1 = 0
    userIds: any[] = []

    // 审批状态
    approveStatus: any[] = [
        { value: 0, label: "待办事项", num: 0 },
        // { value: 1, label: "已处理" ,num:0},
        // { value: 2, label: "已发起" },
    ];
    selectedApproveStatus: any = 0;
    isOnlyView: boolean = false;
    dataGrid?: DataGridApi;

    // 审批页面
    approveRow: any = {};
    showApprovePage: boolean = false;

    cl = 0
    wc = 0
    //#endregion 变量定义区

    //#region 事件定义区

    async created() {
        EventBus.$on("refreshMytodoGrid",()=>{
             this.loadGrid();
        })
        let _this = this;
        // let datas: any = []
        // const result = await this.activitiServiceApi.getTaskList(this.getUserId());
        // // let list: any = result.data;
        // // let res: any
        // // if(this.$globalData_Plms.roleInfo.roleCode == 'manager'){
        // //     // 查部门下的人员id
        // //     await this.loadInstitutionUsers()
        // //     res = list.filter(e => e.FlowCode != 'ExpressApproval' || (e.FlowCode == 'ExpressApproval' && _this.userIds.indexOf(parseInt(e.creator))) != -1)
        // //     datas = res
        // // }else{
        // //     datas = this.parseApiResult(result);
        // // }
        // datas = this.parseApiResult(result);
        // this.cl = datas.length
        // let apiResult = await this.flowApi.hisWork(this.getUserId());
        // datas = this.parseApiResult(apiResult);
        // this.wc = datas.length




    }

    async mounted() {
        await this.loadGrid();
    }

    //#endregion 事件定义区

    //#region 方法定义区

    async doSelectApproveStatus(item) {
        this.activeIndex1 = item.value;
        this.selectedApproveStatus = item.value;
        this.isOnlyView = this.selectedApproveStatus != 0;
        this.loadGrid();
    }

    loadGrid() {
        this.dataGrid = new DataGridApi(this.ref("dataGridRef"));

        this.dataGrid.setOption({
            api: this.actReFlowApi,
            setting: {
                delMsgKey: 'Title',
                isHighlightSelectRow: false,
                isPagination: false,
                operates: '-',
                startEdit: false
            },
            toolbars: [
                // { name: 'refresh1', className: 'primary-color', text: '刷新', onclick: this.loadApproveDatas }
            ],
            columns: [
                {
                    isShowOrderNumber: true,
                },
                {
                    title: '标题',
                    key: 'Title',
                    colType: 'ed',
                    align: 'left',
                    minWidth: 150,
                    format: (h, params) => {
                        return h('a', {
                            on: {
                                click: () => {
                                    this.doApprove(params.row);
                                }
                            }
                        }, params.row.Title)
                    }
                },
                {
                    title: '发起人',
                    key: 'UserName',
                    colType: 'ed',
                    align: "center",
                    width: 140,
                    minWidth:100,
                },
                {
                    title: '发起时间',
                    key: 'SponsorTime',
                    colType: 'ro',
                    align: "center",
                    width: 150,
                    minWidth: 100,
                }
            ]
        });

        this.loadApproveDatas();
    }

    clicMore() {
        let menuData: any = localStorage.getItem("MainMenuDatas");
        const menuTreeList = JSON.parse(menuData);
        let item = {}
        console.log('menuTreeList', menuTreeList);
        menuTreeList.forEach(p => {
            p.children.forEach(ch => {
                if (ch.moduleUrl == '/basics/v2/approveCenter') {

                    item = ch
                }
            })

        })
        console.log('item', item);
        EventBus.$emit("refreshHomeGrid"); //重新刷新首页中间的gird,否则显示高度计算的有问题
        this.$emit("menuClickEvent", item);
    }
    /**
     * 加载审批任务数据
     */
    async loadApproveDatas() {
        let _this = this;
        this.showApprovePage = false
        this.dataGrid!.loadData(async (options) => {
            // 1. 查询任务数据
            let datas: any[] = [];
            // const result = await this.activitiServiceApi.getTaskList(this.getUserId());
            // datas = this.parseApiResult(result);
            // this.cl = datas.length
            // let apiResult = await this.flowApi.hisWork(this.getUserId());
            // datas = this.parseApiResult(apiResult);
            // this.wc = datas.length
            if (this.selectedApproveStatus == 0) { // 待处理
                const result = await this.activitiServiceApi.getTaskListPageST(this.getUserId(),1,20);
                datas = result.data.records
            }
            // else if (this.selectedApproveStatus == 1) { // 已发起
            //     let apiResult = await this.flowApi.hisWork(this.getUserId());
            //     datas = this.parseApiResult(apiResult);
            // }
            // else if (this.selectedApproveStatus == 2) { // 已发起
            //     let apiResult = await this.flowApi.myApplyList(this.getUserId());
            //     datas = this.parseApiResult(apiResult);
            // }
            this.approveStatus = [
                { value: 0, label: "待办事项", num: this.cl },
                // { value: 1, label: "已处理",num:this.wc },
            ];

            if (this.isNull(datas)) {
                options.success([]);
                return;
            }

            // 2. 反向生成业务类别
            this.flowTypes = [];
            const groupBy = this.Baselinq.from(datas).groupBy((item) => item.FlowTypeNo);
            for (const item of groupBy.toArray()) {
                this.flowTypes.push({
                    BusinessType: item.getSource()[0].BusinessType,
                    FlowTypeNo: item.key()
                });
            }

            // 3. 筛选数据
            let newDatas: any[] = datas;
            if (this.selectedType != 'all') {
                newDatas = datas.filter(item => item.FlowTypeNo == this.selectedType);
            }
            if (!this.isNull(this.searchText)) {
                newDatas = newDatas.filter(item => item.Title.indexOf(this.searchText) != -1
                    || item.Abstract.indexOf(this.searchText) != -1
                    || item.UserName.indexOf(this.searchText) != -1)
            }
            newDatas = this.Baselinq.from(newDatas).orderByDescending(item => item.SponsorTime).toArray();
            //过滤掉质保资料相关的流程

            newDatas = newDatas.filter(e=>e.FlowCode!="STJB2JI"&&e.FlowCode!="STCB3JI"&&e.FlowCode!="STJB4JI"&&e.FlowCode!="STJB5JI"&&e.FlowCode!="STCB4JI"
                &&e.FlowCode!="STYB3JI"&&e.FlowCode!="STJLJCB2JI"&&e.FlowCode!="STJLCB1JI"&&e.FlowCode!="shitaizhibao2")

            this.$emit("flowCount",newDatas.length)
            options.success(newDatas);
        });
        this.dataGrid!.resize();
    }

    //查询机构下所有用户；
    async loadInstitutionUsers() {
        let res = await this.userprojectdatarelationApi.getInstitutionUserList({
            projectDataId: this.$globalData_Plms.itemInfo.id,
            institutionId: this.$globalData_Plms.institutioninfor.id,
        });

        if (res.code == 200 && res.data.length > 0) {
            let datas: any = [];
            this.getUsers(res.data, datas);
            if (datas.length > 0) {
                let ids = datas.map(e => e.id);
                this.userIds = ids;
            }
        }
    }
    getUsers(data, datas) {
        data.map(e => {
            if (e.userinfors.length > 0) {
                let users: [] = e.userinfors;
                datas.push(...users)
            }
            //子级
            if (e.children && e.children.length > 0) {
                this.getUsers(e.children, datas);
            }
        })
    }

    /**
     * 执行审批
     * @param row 
     */
    async doApprove(row) {
        this.approveRow = row;
        let res = await this.activitiServiceApi.updateTask(row.Id);
        // if (res.code == 200) {
        //     this.loadApproveDatas();
        // }
        if (row.FlowCode=="STJB2JI"||row.FlowCode=="STCB3JI"||row.FlowCode=="STJB4JI"||row.FlowCode=="STJB5JI"||row.FlowCode=="STCB4JI"
            ||row.FlowCode=="STYB3JI"||row.FlowCode=="STJLJCB2JI"||row.FlowCode=="STJLCB1JI"||row.FlowCode=="shitaizhibao2"){
            this.$emit("menuClickEvent", {
                moduleName: "资料审核",
                moduleUrl: "QA/ReportAuditList",
                loadType:2
            });
            return
        }


        if(row.FlowCode=="EleMeasurement" ||row.FlowCode=="Measurement"||row.FlowCode=="JDMeasurementpayment"
            ||row.FlowCode=="Measurementpayment"
            ||row.FlowCode=="FJMeasurement2"
            ||row.FlowCode=="FJMeasurement1"
            ||row.FlowCode=="LmMeasurement2"
            ||row.FlowCode=="LmMeasurement"
            ||row.FlowCode=="DesignMeasurement"
            ||row.FlowCode=="JDMeasurement"
            ||row.FlowCode=="InterimPaymentApproval"
            ||row.FlowCode=="Measurementpaymentnew"
            ||row.FlowCode=="JLMeasurement"
            ||row.FlowCode=="DesignChange"
        ) {
            this.isOnlyView = true
        }else {
            this.isOnlyView = false
        }
        setTimeout(() => {
            this.$emit("flowCount",0)
            this.showApprovePage = true;
        }, 200)
    }
    refreshDataGrid() {
        this.ref("dataGridRef").resize()
    }
    //#endregion 方法定义区
}
